import { Group, Menu, Text } from "@mantine/core"
import { IconCheckBox } from "../../../-components/icon-check-box"
import { ResponsiveActionIconButton } from "./responsive-action-icon-button"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"
import { IconSettings, IconSettingsBolt } from "@tabler/icons-react"
import { UseStorageReturnValue } from "@mantine/hooks"

type UseState<T> = [T, Dispatch<SetStateAction<T>>]

// type UseLocalStorageState<T> = [
//   T,
//   (val: T | ((prevState: T) => T)) => void,
//   () => void,
// ]

function Item({ checked, label }: { checked: boolean; label: string }) {
  return (
    <Group>
      <IconCheckBox checked={checked} />
      <Text>{label}</Text>
    </Group>
  )
}

export function SettingsMenu({
  quickAdd,
  quickDelete,
  showCastStatus,
}: {
  quickAdd: UseStorageReturnValue<boolean>
  quickDelete: UseStorageReturnValue<boolean>
  showCastStatus: UseState<boolean>
}) {
  const { t } = useTranslation("app_server")
  return (
    <Menu closeOnClickOutside>
      <Menu.Target>
        <ResponsiveActionIconButton
          actionIconProps={{ variant: "default" }}
          buttonProps={{
            variant: "default",
            size: "xs",
            children: t("Settings"),
          }}
          icon={
            quickAdd[0] ? (
              <IconSettingsBolt size={16} />
            ) : (
              <IconSettings size={16} />
            )
          }
        />
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={() => showCastStatus[1]((v) => !v)}>
          <Item checked={showCastStatus[0]} label={t("ShowCastStatus")} />
        </Menu.Item>
        <Menu.Item onClick={() => quickAdd[1]((v) => !v)}>
          <Item checked={quickAdd[0]} label={t("QuickCast")} />
        </Menu.Item>
        <Menu.Item onClick={() => quickDelete[1]((v) => !v)}>
          <Item checked={quickDelete[0]} label={t("QuickDelete")} />
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
